import React, { useState } from 'react';
import { useEventListener } from '@24i/player-utils-react';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { getTelegramWebApp } from '@24i/nxg-sdk-higgs/src/utils';
import { Button } from '../Button/styled';
import { StyledIcon as PlayerIcon } from '../Icons';
import { handleFullscreen } from '../PlayerUIContainer';
const RenderDefaultIcon = (isFullscreen, color, backgroundColor, styles) => (React.createElement(PlayerIcon, { style: styles.icon, "data-test": "FullscreenButton-Icon", className: "FullscreenButton-Icon", name: isFullscreen ? 'onDark-fullscreen_exit' : 'onDark-fullscreen', color, backgroundColor }));
export const FullscreenButton = ({ color, disabledColor, backgroundColor = 'transparent', className = '', playerInstance, customIcon = RenderDefaultIcon, styles = {
    button: null,
    icon: null,
}, }) => {
    var _a, _b;
    const [isFullscreen, setIsFullscreen] = useState(!!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.fullscreen));
    const [webViewFullscreen, setWebViewFullscreen] = useState(false);
    const disabled = !playerInstance;
    const { theme } = useTheme();
    const finalColor = color || ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textSecondary) || 'white';
    const finalDisabledColor = disabledColor || ((_b = theme === null || theme === void 0 ? void 0 : theme.color) === null || _b === void 0 ? void 0 : _b.contrast4) || 'gray';
    const iconColor = !disabled ? finalColor : finalDisabledColor;
    const TelegramWebApp = getTelegramWebApp();
    useEventListener('fullscreenchanged', (event) => {
        setIsFullscreen(event.isFullscreen);
    }, playerInstance);
    const onClickHandler = (event) => {
        handleFullscreen(playerInstance, TelegramWebApp, webViewFullscreen, setWebViewFullscreen);
        if (event)
            event.stopPropagation();
    };
    return (React.createElement(Button, { style: styles.button, "data-test": "FullscreenButton-Button", testID: `${!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.fullscreen) ? 'maximize' : 'minimize'}_button`, className: `${className} FullscreenButton-Button`, onClick: onClickHandler, backgroundColor, disabled }, customIcon(isFullscreen || webViewFullscreen, iconColor, backgroundColor, styles)));
};
//# sourceMappingURL=index.js.map